import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=adf6b8f4&"
import script from "./IconUser.vue?vue&type=script&lang=ts&"
export * from "./IconUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports